document.addEventListener('DOMContentLoaded', function() {
  
  const checkboxes = document.querySelectorAll('input[name="attributes[extra_discreet_shipping]"]');
  
  // טען מצב שמור
  const savedState = sessionStorage.getItem('extra_discreet_shipping');
  checkboxes.forEach(function(cb) {
    if (savedState === 'true') {
      cb.checked = true;
    }
  });
  
  // סנכרון כשמשנים
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      const isChecked = this.checked;
      sessionStorage.setItem('extra_discreet_shipping', isChecked);
      
      // עדכן את כל האחרים
      checkboxes.forEach(function(cb) {
        cb.checked = isChecked;
      });
    });
  });
});
